import {React, useEffect} from 'react';
import {Link} from 'react-router-dom'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Banner from "../Components/Banner";
import LegalServiceCard from "../Card-Components/Legal_Service_card";
import Milestones from '../Card-Components/milestones'
import legal_banner from "../images/banner_images/laptop/legal.png";
import card_image_1 from '../images/liaison/building_planapproval.png'
import card_image_2 from '../images/liaison/landuse_change.png'
import card_image_3 from '../images/liaison/layout_approval.png'
// Components
import OtherServices from "../Card-Components/Other_Services";
import Chatwithus from "../Components/chatwithus";
import Whyus from "../Card-Components/Whyus";
import Testimonial from "../Components/Testimonial";



function LegalService() {

    useEffect(()=>{
        AOS.init({duration:1000});
      }, [])

    const serviceCard = [
        {
            heading:'Legal Opinion & Due-diligence',
            src:card_image_1,
            alt:"Legal Opinion & Due-diligence",
        },
        {
            heading:'Sale Deed & Property Registration ',
            src:card_image_2,
            alt:"Sale Deed & Property Registration ",
        },
        {
            heading:'Registration of Agreements',
            src:card_image_3,
            alt:"Registration of Agreements",
        },
       
    ]

  return (
    <>

      <Banner
        img={legal_banner}
        alt="Banner-Image"
        heading="Accurate property due diligence and legal opinion"
        subheading="Property Legal & Registration serives."
        button="Get Started"
        textposition={"w-[575px] top-48 left-24"}
      />

        {/*Legal Serive */}
        <div className="max-w-7xl mx-auto px-6 my-10 text-center">
            <h2 className="heading" data-aos="fade-up">Property Legal & Registration Services</h2>
            <p className="service-description"data-aos="fade-up" data-aos-duration="1100">Our professional legal and registration services simplify property buying. We review property records,conduct due diligence, and protect your interests. Domain expertise, streamlined procedures, deep local knowledge, and transparent communication ensure accuracy in all of your real estate transactions.</p>
        </div>

        <div className="max-w-6xl mx-auto font-[lato] flex flex-wrap justify-between my-10 sm:my-20" data-aos="fade-up">
            {
            serviceCard.map((items) => {
                return (
                    <div className="relative mx-auto mt-8 w-[296px] h-[521px] bg-[#F6F6F6] pl-10 pt-[39px] transition ease-in-out duration-[650ms] hover:scale-[0.95] cursor-pointer">
                        <h1 className="text-[28px] text-[#000000b3] font-[600] leading-[34px]">{items.heading}</h1>
                        <img className="absolute top-40 right-0 w-[264px] h-[231px] my-6 object-center" src={items.src} alt={items.alt} />
                        <div className="absolute bottom-7 right-16">
                        <Link to = "/comingsoon">
                            <button className="bg-yellow font-[lato] text-[#191915] w-[147px] text-center py-[11px] text-[14px] font-semibold leading-[16px] uppercase tracking-[1.4px]">Explore</button>
                        </Link>
                        </div> 
                    </div>
                );
            })}
        </div>

        <LegalServiceCard />

        <Whyus />

        <Milestones />
        
        <Chatwithus />

        {/* Testimonial */}
        <Testimonial />
        
        <OtherServices />

    </>
  );
}

export default LegalService;
